import { useState } from "react";
import { toast } from "react-toastify";
import { PostCallWithErrorResponse } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { useDispatch, useSelector } from "react-redux";
import { updateData } from "../redux/roundtoSlice";
import { useContext } from "react";
import { AppContext } from "../contaxt/AppContext";

function OtpVerification({ userId, email, getToken, handleNavigation, getUserDetails }) {

    const {

        setIsShowMsgLgn,

    } = useContext(AppContext)
    const [otp, setOtp] = useState(new Array(6).fill(""));

    const [isApiCalled, setIsApiCalled] = useState(false)

    const state = useSelector(state => state.roundData)

    const dispatch = useDispatch();

    const handleKeyDown = (e, index) => {
        const inputs = document.querySelectorAll('#otpBox input[name="otp"]');

        if (e.key === "Backspace") {
            let newOtp = [...otp];

            if (otp[index]) {
                // ✅ clear current value
                newOtp[index] = "";
                setOtp(newOtp);
            } else if (inputs[index - 1]) {
                // ✅ move to previous
                inputs[index - 1].focus();
            }
        }

        if (e.key === "ArrowLeft" && inputs[index - 1]) {
            inputs[index - 1].focus();
        }

        if (e.key === "ArrowRight" && inputs[index + 1]) {
            inputs[index + 1].focus();
        }
    };

    const handleChange = (element, index) => {
        const val = element.value.replace(/\D/g, "");

        if (!val) return;

        let newOtp = [...otp];
        newOtp[index] = val[0]; // ✅ only one digit
        setOtp(newOtp);

        const inputs = document.querySelectorAll('#otpBox input[name="otp"]');
        if (inputs[index + 1]) {
            inputs[index + 1].focus();
        }
    };

    const handleVerifyOtp = () => {

        if (otp.join("").length != 6) {
            toast.error("Please enter a valid 6-digit OTP");
            return
        }

        let payload = {
            "emailId": email,
            "code": state.code,
            "otp": otp.join(""),
            userId: userId
        }

        setIsApiCalled(true)

        PostCallWithErrorResponse(ApiConfig.VERIFY_OTP, payload).then(async (res) => {

            if (res?.json?.response?.status) {
                toast.success(res?.json?.response?.statusMessage);

                let token = await getToken(userId, otp.join(""))



                localStorage.setItem("customer_id", userId);
                dispatch(
                    updateData({ field: "userId", value: userId })
                );
                dispatch(
                    updateData({ field: "otp", value: otp.join("") })
                );

                if (res?.json?.response?.currentStep?.currentStep == 3 && !res?.json?.response?.isAssessmentStarted) {
                    let details = await getUserDetails(userId, token)
                    handleNavigation(4)
                } else {
                    handleNavigation(res?.json?.response?.currentStep?.currentStep)
                }

                setIsApiCalled(false)

                setIsShowMsgLgn(false)




            } else {
                toast.error(res?.json?.response?.statusMessage);
            }

        })

    }

    return (
        <div>
            <p
                className="mb-3 mt-2 text-center"
                style={{ fontSize: "16px", color: "#172B4D" }}
            >
                It seems you have already started your application. Please verify your
                email using the OTP we’ve sent, or continue using the link sent to your
                email.
            </p>

            {/* ✅ IMPORTANT: added id */}
            <div
                id="otpBox"
                className="input-group"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                }}
            >
                {otp.map((data, index) => (
                    <input
                        key={index}
                        type="tel"
                        inputMode="numeric"
                        className="form-control bg-white"
                        name="otp"
                        maxLength="1"
                        value={data}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={(e) => {
                            e.preventDefault();
                            const pasted = e.clipboardData
                                .getData("text")
                                .replace(/\D/g, "")
                                .substring(0, 6);

                            if (!pasted) return;

                            const newOtp = new Array(6).fill("");
                            pasted.split("").forEach((char, i) => {
                                newOtp[i] = char;
                            });

                            setOtp(newOtp);

                            const inputs = document.querySelectorAll(
                                '#otpBox input[name="otp"]'
                            );
                            if (inputs[pasted.length - 1]) {
                                inputs[pasted.length - 1].focus();
                            }
                        }}
                        onChange={(e) => handleChange(e.target, index)}
                        onFocus={(e) => e.target.select()}
                        required
                        style={{
                            maxWidth: "50px",
                            height: "2.5rem",
                            textAlign: "center",
                        }}
                    />
                ))}
            </div>
            <button
                className="comp-nxtbtn px-3 ms-0 mt-3"
                onClick={handleVerifyOtp}
                disabled={isApiCalled}
            // disabled={percentage != "100"}
            // style={{
            //     opacity: percentage == "100" ? 1 : 0.5,
            //     cursor: percentage == "100" ? "pointer" : "not-allowed",
            // }}
            >
                Verify Otp
            </button>
        </div>
    );
}

export default OtpVerification;